module.exports = "/_next/static/images/Connections@2x-de7d4134eed4f7ba938b6f7a7f020fbb.png";